import { generateClasses } from '@formkit/themes';
import myTailwindTheme from './formkit-tailwind-theme.js';

export default {
  config: {
    classes: generateClasses(myTailwindTheme),
  },
};
